import * as S from "components/common/Banner/Overlay.style";

const CorporativeCultureOverlay = () => (
  <S.Overlay>
    <S.TextBanner variant="headline-01" color="white">
      <S.MainInfo>O nosso DNA</S.MainInfo>
    </S.TextBanner>
    <S.TextBanner variant="headline-01" color="white">
      <S.SecondaryInfo>Conheça o jeito CSH de ser</S.SecondaryInfo>
    </S.TextBanner>
    <S.BannerIndicator />
  </S.Overlay>
);
export default CorporativeCultureOverlay;
